const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisponibilizar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-220"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.73,160.69l-.45-13.14,8.07-2.63a78,78,0,0,1,2.15-13.2l-6.84-5,4.64-12.35,8.46.69a77.64,77.64,0,0,1,7-11.35l-4.38-7.32,9-9.61L313,90.61a83.63,83.63,0,0,1,10.84-7.83l-1.22-8.39,12-5.45,5.5,6.44a81.73,81.73,0,0,1,13-3l2-8.22,13.18-.46,2.6,8.07a82.67,82.67,0,0,1,13.19,2.15l5.08-6.8,12.35,4.61-.69,8.46a80.47,80.47,0,0,1,11.35,7.07l7.28-4.38,9.65,9-3.87,7.59a78.21,78.21,0,0,1,7.8,10.84l8.39-1.26L447,121l-6.48,5.5a78.3,78.3,0,0,1,3,13l8.26,2.07.45,13.14-8.1,2.64a77.35,77.35,0,0,1-2.15,13.2l6.84,5-4.65,12.34-8.45-.68a77.37,77.37,0,0,1-7.05,11.35l4.39,7.31-9,9.62-7.56-3.88a80.81,80.81,0,0,1-10.84,7.84l1.26,8.39-12,5.44-5.53-6.44a80.66,80.66,0,0,1-13,3.05l-2,8.23-13.18.45-2.6-8.07a80.42,80.42,0,0,1-13.2-2.15l-5,6.8L328,230.58l.65-8.45a81.34,81.34,0,0,1-11.35-7.08L310,219.43l-9.65-9,3.87-7.6A77.61,77.61,0,0,1,296.4,192L288,193.28l-5.48-12,6.48-5.5a77.61,77.61,0,0,1-3.05-13Zm88.79,42.57a52.16,52.16,0,1,0-53.89-50.32A52.14,52.14,0,0,0,366.52,203.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.77,316.43l-.2-5.92,3.64-1.19a35.67,35.67,0,0,1,1-5.95l-3.08-2.27,2.09-5.57,3.81.31a35,35,0,0,1,3.18-5.12l-2-3.3,4.07-4.33,3.4,1.75a37.78,37.78,0,0,1,4.89-3.54l-.55-3.78,5.41-2.46L147.9,278a37.46,37.46,0,0,1,5.87-1.38l.92-3.71,5.94-.2,1.17,3.64a36.21,36.21,0,0,1,5.95,1l2.29-3.07,5.57,2.08-.31,3.81a37.83,37.83,0,0,1,5.12,3.19l3.28-2,4.35,4-1.75,3.43a34.08,34.08,0,0,1,3.52,4.89l3.79-.57,2.47,5.41L193.16,301a35.8,35.8,0,0,1,1.37,5.87l3.73.93.2,5.93-3.65,1.19a35.34,35.34,0,0,1-1,5.95l3.08,2.27-2.09,5.57-3.82-.31a35.82,35.82,0,0,1-3.17,5.12l2,3.29-4.06,4.34-3.41-1.75a35.83,35.83,0,0,1-4.89,3.54l.57,3.78-5.41,2.45-2.49-2.9a37.72,37.72,0,0,1-5.87,1.38l-.92,3.71-5.94.2-1.18-3.64a36.38,36.38,0,0,1-6-1L148,350,142.42,348l.3-3.81A37.83,37.83,0,0,1,137.6,341l-3.28,2-4.35-4,1.74-3.43a34.87,34.87,0,0,1-3.52-4.89l-3.78.57-2.47-5.41,2.92-2.48a35.34,35.34,0,0,1-1.38-5.87Zm40,19.2a23.52,23.52,0,1,0-24.3-22.69A23.52,23.52,0,0,0,159.81,335.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.69,96,114.38,93l1.32-2.61A27.08,27.08,0,0,1,113,86.59l-2.9.44-1.87-4.14,2.22-1.9a26.73,26.73,0,0,1-1-4.48l-2.85-.72-.14-4.54,2.78-.9a28.2,28.2,0,0,1,.74-4.55l-2.35-1.75,1.6-4.25,2.91.23a28.25,28.25,0,0,1,2.43-3.92L113,53.61l3.1-3.33,2.61,1.34a28.32,28.32,0,0,1,3.74-2.7L122.05,46l4.13-1.89,1.9,2.23a27.83,27.83,0,0,1,4.49-1l.71-2.84,4.54-.17.91,2.8a26,26,0,0,1,4.54.74L145,43.51l4.26,1.58L149,48A26.58,26.58,0,0,1,153,50.44l2.52-1.5L158.79,52l-1.34,2.62a26,26,0,0,1,2.7,3.74L163,58l1.88,4.15L162.69,64a26.84,26.84,0,0,1,1.05,4.49l2.86.71.14,4.54-2.79.9a27.4,27.4,0,0,1-.73,4.56l2.36,1.73L164,85.18,161.06,85a28.15,28.15,0,0,1-2.43,3.91l1.51,2.51L157,94.7l-2.6-1.33a28.24,28.24,0,0,1-3.74,2.69l.43,2.89L147,100.84l-1.9-2.22a28.94,28.94,0,0,1-4.49,1l-.71,2.84-4.54.16-.91-2.79a26.86,26.86,0,0,1-4.54-.74l-1.74,2.35-4.26-1.59.23-2.92a26.69,26.69,0,0,1-3.91-2.43Zm23.62-19.13a6.47,6.47,0,1,0-9.15.31A6.46,6.46,0,0,0,141.31,76.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,311l7.56-5.22v0a41.1,41.1,0,0,1,3-7.87l-1.94-7.61,11-11.75,7.72,1.42a41.28,41.28,0,0,1,7.64-3.57h0l4.7-7.9,16.06-.55,5.22,7.56h0a40.82,40.82,0,0,1,7.87,3l7.6-1.93,11.75,11-1.41,7.7h0a40.25,40.25,0,0,1,3.57,7.67l7.91,4.69.55,16.07-7.57,5.22a40.88,40.88,0,0,1-3,7.92h0l1.93,7.58-11,11.75-7.68-1.41a42.31,42.31,0,0,1-7.71,3.58h0l-4.69,7.89-16.06.55-5.22-7.55a42.43,42.43,0,0,1-7.94-3h0l-7.56,1.92-11.75-11,1.41-7.71a40.33,40.33,0,0,1-3.57-7.68h0l-7.91-4.69Zm50.06,24.42A18.07,18.07,0,1,0,240.76,318,18.08,18.08,0,0,0,259.44,335.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,121a1.12,1.12,0,0,1-.93-.49l-2.79-4a26.06,26.06,0,0,1-4-1.54l-4,1a1.11,1.11,0,0,1-1.06-.27l-6.8-6.35a1.11,1.11,0,0,1-.35-1l.75-4a24.23,24.23,0,0,1-1.81-3.89l-4.23-2.52a1.15,1.15,0,0,1-.56-.93L48,87.54a1.15,1.15,0,0,1,.49-1l4-2.79a23.87,23.87,0,0,1,1.54-4l-1-4a1.17,1.17,0,0,1,.27-1.06l6.36-6.8a1.13,1.13,0,0,1,1-.34l4.06.74a25.27,25.27,0,0,1,3.88-1.81l2.51-4.23a1.13,1.13,0,0,1,.94-.55l9.3-.32a1.15,1.15,0,0,1,1,.49l2.79,4a25.43,25.43,0,0,1,4,1.54l4-1a1.15,1.15,0,0,1,1,.27L101,73.09a1.13,1.13,0,0,1,.34,1l-.74,4a25.61,25.61,0,0,1,1.81,3.9l4.23,2.51a1.12,1.12,0,0,1,.55.93l.32,9.31a1.14,1.14,0,0,1-.49,1l-4,2.8a25,25,0,0,1-1.53,4l1,4a1.14,1.14,0,0,1-.27,1.06l-6.35,6.8a1.16,1.16,0,0,1-1,.34l-4-.74a24.65,24.65,0,0,1-3.91,1.82l-2.51,4.22a1.13,1.13,0,0,1-.94.55l-9.3.32Zm-7.62-8.41a1.16,1.16,0,0,1,.51.12,22.32,22.32,0,0,0,4.38,1.68,1.13,1.13,0,0,1,.64.45l2.67,3.87,8.07-.27,2.39-4a1.19,1.19,0,0,1,.64-.51,23.06,23.06,0,0,0,4.23-2,1.15,1.15,0,0,1,.79-.14l3.83.7,5.51-5.9-1-3.79a1.17,1.17,0,0,1,.09-.8,22.11,22.11,0,0,0,1.67-4.36,1.1,1.1,0,0,1,.46-.64l3.87-2.67L105,86.21l-4-2.4a1.1,1.1,0,0,1-.49-.61,22.42,22.42,0,0,0-2-4.2,1.18,1.18,0,0,1-.16-.82L99,74.32l-5.9-5.5-3.8,1a1.23,1.23,0,0,1-.8-.09A22.91,22.91,0,0,0,84.2,68a1.16,1.16,0,0,1-.65-.45L80.87,63.7,72.81,64,70.4,68a1.05,1.05,0,0,1-.44.42l-.23.1a21.75,21.75,0,0,0-4.16,1.95,1.14,1.14,0,0,1-.79.14l-3.86-.71-5.51,5.9,1,3.8a1.16,1.16,0,0,1-.08.8,22.51,22.51,0,0,0-1.68,4.34,1.17,1.17,0,0,1-.46.65l-3.87,2.67.28,8.07,4,2.4a1.14,1.14,0,0,1,.49.61,22.43,22.43,0,0,0,2,4.23,1.15,1.15,0,0,1,.14.79l-.7,3.85,5.9,5.51,3.78-1A.86.86,0,0,1,66.48,112.54Zm33-34.16h0ZM77.76,108.19a17,17,0,1,1,.6,0h-.6Zm0-31.75h-.52a14.74,14.74,0,0,0,1,29.47h0a14.74,14.74,0,0,0-.49-29.48Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-220"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-220",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Website--inject-220"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.78,
    y: 82.46,
    width: 362.44,
    height: 242.41,
    rx: 14.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.26,247.65h-1v-9h1Zm0-16.1h-1V212.89h1Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.41,325.41H83.59a15.37,15.37,0,0,1-15.35-15.35V97.27A15.36,15.36,0,0,1,83.59,81.92H416.41a15.36,15.36,0,0,1,15.35,15.35V310.06A15.37,15.37,0,0,1,416.41,325.41ZM83.59,83A14.28,14.28,0,0,0,69.32,97.27V310.06a14.28,14.28,0,0,0,14.27,14.27H416.41a14.28,14.28,0,0,0,14.27-14.27V97.27A14.28,14.28,0,0,0,416.41,83Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.8,274.75h-5v-1.08h5l.09,1.08Zm-10.08,0h-5.05v-1.08h5.05Zm-10.09,0h-5v-1.08h5Zm-10.08,0H154.5v-1.08h5.05Zm-10.09,0h-5v-1.08h5Zm-10.09,0h-5v-1.08h5Zm-10.08,0h-5v-1.08h5Zm-10.09,0h-5v-1.08h5Zm-10.08,0h-5v-1.08h5Zm-10.09,0H97.15a7.24,7.24,0,0,1-3.29-.78l.48-1a6.22,6.22,0,0,0,2.81.67H99Zm95.79-2-.73-.79a6.26,6.26,0,0,0,2-4.09l1.08.09A7.36,7.36,0,0,1,194.82,272.77ZM90.28,270a7.5,7.5,0,0,1-.49-2.65v-2.54h1.08v2.54a6.21,6.21,0,0,0,.42,2.26Zm106.88-7.15h-1.08v-5h1.08ZM90.87,259.81H89.79v-5h1.08Zm106.29-7h-1.08v-5h1.08ZM90.87,249.73H89.79v-5h1.08Zm106.29-7h-1.08v-5h1.08ZM90.87,239.64H89.79v-5h1.08Zm106.29-7h-1.08v-5h1.08ZM90.87,229.56H89.79v-5.05h1.08Zm106.29-7h-1.08v-5h1.08ZM90.87,219.47H89.79v-5h1.08Zm106.29-7h-1.08v-5.05h1.08ZM90.87,209.38H89.79v-5h1.08Zm106.29-7h-1.08v-5h1.08ZM90.87,199.3H89.79v-5h1.08Zm106.29-7h-1.08v-5.05h1.08ZM90.87,189.21H89.79v-5h1.08Zm106.29-7h-1.08v-5h1.08ZM90.87,179.13H89.79v-5h1.08Zm106.29-7h-1.08v-5h1.08ZM90.87,169H89.79v-5h1.08Zm106.29-7h-1.08v-5h1.08ZM90.87,159H89.79v-5.05h1.08Zm106.29-7h-1.08v-2.49a6.17,6.17,0,0,0-.43-2.29l1-.4a7.26,7.26,0,0,1,.51,2.69Zm-106.26-3-1.08-.09a7.38,7.38,0,0,1,2.34-4.78l.74.8A6.2,6.2,0,0,0,90.9,148.92Zm101.68-5.09a6.21,6.21,0,0,0-2.78-.65h-1.92V142.1h1.92a7.36,7.36,0,0,1,3.26.76Zm-9.74-.65h-5V142.1h5Zm-10.09,0h-5V142.1h5Zm-10.08,0h-5V142.1h5Zm-10.09,0h-5V142.1h5Zm-10.08,0h-5.05V142.1h5.05Zm-10.09,0h-5V142.1h5Zm-10.08,0h-5V142.1h5Zm-10.09,0h-5V142.1h5Zm-10.09,0h-5l0-1.08h5Z",
    style: {
      fill: "#5D7366",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.42,98.06a4.78,4.78,0,1,1-4.77-4.78A4.78,4.78,0,0,1,97.42,98.06Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76,100.85H105.35a2.81,2.81,0,0,1-2.8-2.79h0a2.81,2.81,0,0,1,2.8-2.8h23.41a2.81,2.81,0,0,1,2.8,2.8h0A2.81,2.81,0,0,1,128.76,100.85Z",
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.66,99.59H225.23a1.53,1.53,0,0,1-1.53-1.53h0a1.52,1.52,0,0,1,1.53-1.53h16.43a1.52,1.52,0,0,1,1.53,1.53h0A1.53,1.53,0,0,1,241.66,99.59Z",
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.53,99.59H262.1a1.54,1.54,0,0,1-1.53-1.53h0a1.53,1.53,0,0,1,1.53-1.53h16.43a1.52,1.52,0,0,1,1.53,1.53h0A1.53,1.53,0,0,1,278.53,99.59Z",
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4,99.59H299a1.54,1.54,0,0,1-1.53-1.53h0A1.53,1.53,0,0,1,299,96.53H315.4a1.53,1.53,0,0,1,1.54,1.53h0A1.54,1.54,0,0,1,315.4,99.59Z",
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.28,99.59H335.84a1.54,1.54,0,0,1-1.53-1.53h0a1.53,1.53,0,0,1,1.53-1.53h16.44a1.53,1.53,0,0,1,1.53,1.53h0A1.54,1.54,0,0,1,352.28,99.59Z",
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.46,100.76H374.6a2.7,2.7,0,0,1-2.7-2.7h0a2.7,2.7,0,0,1,2.7-2.71h24.86a2.7,2.7,0,0,1,2.7,2.71h0A2.7,2.7,0,0,1,399.46,100.76Z",
    style: {
      fill: "#5D7366",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 270.74,
    width: 58.08,
    height: 12.77,
    rx: 5.76,
    style: {
      fill: "#5D7366",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.1,213.69V165.07a1.52,1.52,0,0,1,1.53-1.53h0a1.53,1.53,0,0,1,1.53,1.53v48.62a1.53,1.53,0,0,1-1.53,1.53h0A1.52,1.52,0,0,1,399.1,213.69Z",
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.63,
    cy: 227.56,
    r: 1.53,
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.63,
    cy: 249.18,
    r: 1.53,
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.63,
    cy: 270.8,
    r: 1.53,
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.7,
    y: 142.64,
    width: 143.02,
    height: 24.55,
    rx: 12.28,
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,202.84H236a12.31,12.31,0,0,1-12.28-12.28h0A12.31,12.31,0,0,1,236,178.28h75a12.31,12.31,0,0,1,12.27,12.28h0A12.31,12.31,0,0,1,311,202.84Z",
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,231.55H226.57a2.88,2.88,0,0,1-2.87-2.87h0a2.88,2.88,0,0,1,2.87-2.87H333a2.88,2.88,0,0,1,2.87,2.87h0A2.88,2.88,0,0,1,333,231.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.05,231.55H347.16a2.88,2.88,0,0,1-2.87-2.87h0a2.88,2.88,0,0,1,2.87-2.87h10.89a2.88,2.88,0,0,1,2.87,2.87h0A2.88,2.88,0,0,1,358.05,231.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,237.69h45.77a2.88,2.88,0,0,1,2.87,2.87h0a2.88,2.88,0,0,1-2.87,2.87H273.47a2.88,2.88,0,0,1-2.87-2.87h0A2.88,2.88,0,0,1,273.47,237.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,237.69h32.77a2.88,2.88,0,0,1,2.87,2.87h0a2.88,2.88,0,0,1-2.87,2.87H226.57a2.88,2.88,0,0,1-2.87-2.87h0A2.88,2.88,0,0,1,226.57,237.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.06,255.31H226.57a2.88,2.88,0,0,1-2.87-2.87h0a2.88,2.88,0,0,1,2.87-2.87h64.49a2.88,2.88,0,0,1,2.87,2.87h0A2.88,2.88,0,0,1,291.06,255.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,255.31H305.18a2.88,2.88,0,0,1-2.87-2.87h0a2.88,2.88,0,0,1,2.87-2.87H338a2.88,2.88,0,0,1,2.87,2.87h0A2.88,2.88,0,0,1,338,255.31Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-220"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.79,
    y: 134.41,
    width: 106.29,
    height: 131.56,
    rx: 6.7,
    transform: "translate(-34.58 33.82) rotate(-10.78)",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.12,269.48a.53.53,0,0,1-.24-.06.51.51,0,0,1-.2-.68L198.3,131.16a.5.5,0,1,1,.88.48L125.56,269.21A.51.51,0,0,1,125.12,269.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.44,251.14a.51.51,0,0,1-.32-.12l-119-100.9a.49.49,0,0,1-.06-.7.51.51,0,0,1,.71-.06l119,100.89a.52.52,0,0,1,.06.71A.5.5,0,0,1,221.44,251.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.77,264.07s13,45.33,18.34,67.59c5.56,23.38,22.09,58.72,23.47,74.22,1.43.57,6.06-.07,8.53-1.27,0,0-2.26-49.41-15.7-71.91,3-55.39-12-68.63-12-68.63Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.67,286.84l-7.34,11.27c2.33,8.5,4.71,17.36,6.65,25C228,309.9,226.67,286.84,226.67,286.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.69,225c.21.62.36,1.06.51,1.58s.28,1,.42,1.48c.27,1,.48,2,.69,3a58.07,58.07,0,0,1,.9,6,48.28,48.28,0,0,1,.26,6.14,45.08,45.08,0,0,1-.5,6.22l0,.34a3.76,3.76,0,0,1-.17.68,10.43,10.43,0,0,1-2,3.29,13.51,13.51,0,0,1-2.42,2.1,19.23,19.23,0,0,1-4.83,2.27,28.71,28.71,0,0,1-4.68,1,30,30,0,0,1-4.68.27,2.73,2.73,0,0,1-1.07-5.2l.23-.11c1.14-.52,2.43-1.07,3.59-1.64a37.11,37.11,0,0,0,3.33-1.82,13.38,13.38,0,0,0,2.52-2c.62-.64.79-1.22.69-1.26l-.22,1c0-1.66,0-3.31-.1-5s-.31-3.36-.58-5-.56-3.39-.94-5.06c-.18-.84-.39-1.68-.59-2.51l-.31-1.22-.3-1.11-.08-.29A5.42,5.42,0,0,1,236.69,225Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,254.24l-6.53-1.86a4,4,0,0,0-2.82.22l-2.44,1.11a2.35,2.35,0,0,0-1.14,3.16l1.14,2.36a2.34,2.34,0,0,0,2.61,1.28l4.38-.95s4.92.32,6.66-2.6Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,215.84c-3.5,3.63-5.37,9.1-2.53,19.55,3.74,1.85,12.8-.55,12.8-.55S239.89,219.14,229.49,215.84Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,215.84c-3.5,3.63-5.37,9.1-2.53,19.55,3.74,1.85,12.8-.55,12.8-.55S239.89,219.14,229.49,215.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.84,223.13a.32.32,0,0,0-.32.34.33.33,0,0,0,.33.31h0l1.63-.06c-.09-.21-.19-.43-.29-.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.46,229.59a.33.33,0,0,0-.46,0,.33.33,0,0,0,0,.47l4.7,4c0-.25,0-.55-.05-.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,230.75l5.29-3.32a.33.33,0,0,0-.35-.56l-5.06,3.18C225.87,230.28,225.92,230.52,226,230.75Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.53,200.19c-.66,4.59-1.13,12.92,2.12,15.53,0,0-4.29-.11-12.55,6.52-3-3.4-1.27-4.82-1.27-4.82,4.9-1.8,4.6-5.5,3.57-8.88Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.56,194.58c-.15.6-.59,1-1,1s-.58-.61-.43-1.21.58-1,1-1S207.71,194,207.56,194.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.29,193.44l-1.31-.67S206.42,194,207.29,193.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.3,195.72a18.13,18.13,0,0,1-3.07,3.45,2.46,2.46,0,0,0,2,.78Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.05,189.63a.33.33,0,0,1,0-.26.36.36,0,0,1,.47-.19,3.77,3.77,0,0,1,2.37,2.37.33.33,0,0,1-.27.41.4.4,0,0,1-.44-.28,3,3,0,0,0-1.9-1.86A.33.33,0,0,1,207.05,189.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.63,195.9c-2.1,7-2.84,10.08-7.3,13.1-6.72,4.55-14.91.92-15-6.5,0-6.68,3.4-17.09,11.06-18.7A9.43,9.43,0,0,1,227.63,195.9Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,196.34c-4.18-3-2.14-8.42,1.69-8.59-5-3.5-2.39-9.83,3.72-9.58s7,4,7,4,9.86.5,11.24,7.66c1.63,8.44-3.52,13.84-9.86,16.34,4.31,3.53-5.85,6-10.91,3.16S207.2,200.1,211.31,196.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,186.87c-5.37-1-8.07,6.44-4.57,10.78a8.46,8.46,0,0,0,1.8,1.7,3.5,3.5,0,0,0,5.39-2.67C237.41,193.11,237.4,187.4,234.5,186.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,190.67a1.63,1.63,0,0,0,.71-1.14c.23-2.1-1.36-3.47-3.27-3.77-1.15-3.65-6-3.72-8.73-1.1-2.24-1.14-4.72,1.37-4.42,4-2.35,1-3,5-.82,7.22a5.48,5.48,0,0,0,1.3,1,1.79,1.79,0,0,0,.32.13,4.05,4.05,0,0,0,3.16,3.39,4.61,4.61,0,0,0,1.35.08,1.84,1.84,0,0,0,1.5-1.11c1.56,1.28,3.23,2.12,4.42,1.29a3.83,3.83,0,0,0,1.7-3.41,2.3,2.3,0,0,0,2.24-.08C250.85,195.6,250.65,192.74,249.09,190.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,197.4a5,5,0,0,1-3.3,2.4c-1.72.29-2.27-1.69-1.54-3.56.66-1.68,2.35-3.86,4-3.3S214.6,195.79,213.6,197.4Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,192.17c1.47-2.81,9.52-10.48,14.88-10.2a15.82,15.82,0,0,1,3.17,1.26.2.2,0,0,1-.08.38c-2.1.25-8.92,1.83-15.32,11.89A10.26,10.26,0,0,1,211.31,192.17Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.52,197.88c-1.29,2.87-3.88,4.51-5.79,3.65s-2.41-3.88-1.12-6.76,3.89-4.51,5.8-3.65S215.81,195,214.52,197.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.94,197.17c-1.16,2.59-3.4,4.12-5,3.4s-1.94-3.4-.77-6,3.4-4.12,5-3.41S214.11,194.57,212.94,197.17Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.27,416.21c5.61-.84,5.72-1.77,8.73-2.83,2.58-.91,3.31-.77,5.39-1.48,1.74-.58,1.15-2.24,0-4a19.92,19.92,0,0,1-1.29-3.29l-8.53,1.27c-.83,2.38-1.13,5.43-6,7.17C242.68,414.09,245,416.54,247.27,416.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23,416.23c5.58,0,6.65-.37,9.79-.48,2.69-.09,3.13.48,5.86.48,1.8,0,2.05-2,1.39-3.56a29.31,29.31,0,0,1-1-4.15h-7.69c-1.39,2.44-5.18,4.24-9.41,4.55C191.18,413.29,193,416.23,195.23,416.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.75,264.07s-1.11,40.16,1.27,65.67c-.15,23.94.59,78.78.59,78.78.18,1.22,6.61.73,7.69,0,0,0,12-39.94,6.69-78.78,13.37-40.51,10.49-65.67,10.49-65.67Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46,402.77a22.07,22.07,0,0,1,.17,3.2.67.67,0,0,0,.67.7c3.2,0,7.61-1.36,9-1.83a.66.66,0,0,0,.44-.62l0-3a.66.66,0,0,0-.77-.66l-9,1.51A.65.65,0,0,0,250.46,402.77Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46,402.77a22.07,22.07,0,0,1,.17,3.2.67.67,0,0,0,.67.7c3.2,0,7.61-1.36,9-1.83a.66.66,0,0,0,.44-.62l0-3a.66.66,0,0,0-.77-.66l-9,1.51A.65.65,0,0,0,250.46,402.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.73,405.14c0,.84-.08,2.32-.15,3.41a.69.69,0,0,0,.61.73,45.4,45.4,0,0,0,8.49-.09.64.64,0,0,0,.56-.51l.57-3a.7.7,0,0,0-.66-.82l-8.76-.34A.62.62,0,0,0,202.73,405.14Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.73,405.14c0,.84-.08,2.32-.15,3.41a.69.69,0,0,0,.61.73,45.4,45.4,0,0,0,8.49-.09.64.64,0,0,0,.56-.51l.57-3a.7.7,0,0,0-.66-.82l-8.76-.34A.62.62,0,0,0,202.73,405.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.67,230.41a137.38,137.38,0,0,0,1.91,13.89c1,6,1.7,11.89,3.12,21.81,13.79,1.45,30,.28,30.71-2-1.08-8.59-1-20.19,2-40.14a7.16,7.16,0,0,0-7.21-8.48c-1.22,0-2.51.08-3.83.18a97.41,97.41,0,0,0-13.82,1.7c-1.48.32-3,.7-4.48,1.09A11.54,11.54,0,0,0,196.67,230.41Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.67,230.41a137.38,137.38,0,0,0,1.91,13.89c1,6,1.7,11.89,3.12,21.81,13.79,1.45,30,.28,30.71-2-1.08-8.59-1-20.19,2-40.14a7.16,7.16,0,0,0-7.21-8.48c-1.22,0-2.51.08-3.83.18a97.41,97.41,0,0,0-13.82,1.7c-1.48.32-3,.7-4.48,1.09A11.54,11.54,0,0,0,196.67,230.41Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.13,222.39l1.61,2a.32.32,0,0,0,.25.12.31.31,0,0,0,.21-.07.33.33,0,0,0,.05-.46l-1.68-2.11C199.42,222,199.27,222.21,199.13,222.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.47,221.21h0a.34.34,0,0,0,.33-.31l.18-3-.67.17-.17,2.75A.33.33,0,0,0,206.47,221.21Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.84,223.86a.32.32,0,0,0,.19,0,.33.33,0,0,0,.18-.6l-8.41-5.55a.34.34,0,0,0-.46.09.32.32,0,0,0,.1.45Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,225.72a.33.33,0,0,0,.19.43l9.38,3.67.12,0a.34.34,0,0,0,.31-.21.33.33,0,0,0-.19-.42l-9.39-3.68A.33.33,0,0,0,206.5,225.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.08,242.43a.33.33,0,0,0,.45-.1l5.47-8.47a.33.33,0,0,0-.1-.45.32.32,0,0,0-.45.1L201,242A.34.34,0,0,0,201.08,242.43Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4,235a.35.35,0,0,0,.23.09.33.33,0,0,0,.22-.57l-2-1.84c0,.32.06.66.1,1Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.07,240.63a.34.34,0,0,0-.2.43.33.33,0,0,0,.31.21.22.22,0,0,0,.11,0l4.16-1.52c0-.24.05-.48.07-.72Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.29,233.86a.34.34,0,0,0,.17-.05l7.21-4.53.12-.85-7.68,4.82a.33.33,0,0,0-.1.45A.33.33,0,0,0,226.29,233.86Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,235.12a.34.34,0,0,0-.46-.1l-8.53,5.36a.34.34,0,0,0-.1.46.35.35,0,0,0,.28.15.34.34,0,0,0,.17-.05l8.53-5.36A.34.34,0,0,0,221.37,235.12Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.56,223.77l.12,0a.34.34,0,0,0,.19-.43l-3-7.83-.69,0,3,8A.33.33,0,0,0,228.56,223.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.09,264.74a.32.32,0,0,0-.45.09.34.34,0,0,0,.09.46l1.87,1.23,1.08-.07Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,261.63l-7.28-2.85a.33.33,0,1,0-.24.61l7.59,3C232.19,262.12,232.17,261.87,232.15,261.63Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.38,263.8c0,.2.05.4.08.61a.33.33,0,0,0,.21-.29A.33.33,0,0,0,201.38,263.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.29,253.74a.33.33,0,0,0,.21-.58l-1.82-1.53c0,.32.09.64.14,1l1.25,1.06A.37.37,0,0,0,201.29,253.74Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.65,250.45a.34.34,0,0,0,.31-.21.33.33,0,0,0-.19-.42l-9.38-3.68a.33.33,0,0,0-.43.19.32.32,0,0,0,.19.42l9.38,3.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.48,254.79l-8.54,5.36a.34.34,0,0,0-.1.46.32.32,0,0,0,.28.15.34.34,0,0,0,.17-.05l8.54-5.36a.34.34,0,0,0,.1-.46A.33.33,0,0,0,214.48,254.79Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.35,252.24a.34.34,0,0,0,.28.16.32.32,0,0,0,.18-.06l8.53-5.36a.33.33,0,0,0-.35-.55l-8.53,5.36A.33.33,0,0,0,222.35,252.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.69,265a.33.33,0,0,0-.62.24l.55,1.45h.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.74,230.6c-.08.66-.14,1.12-.22,1.65s-.18,1-.27,1.52c-.19,1-.41,2-.65,3a54.69,54.69,0,0,1-1.77,5.81,50.71,50.71,0,0,1-2.41,5.65,46.41,46.41,0,0,1-3.13,5.4l-.21.32a2.93,2.93,0,0,1-.42.5,42.56,42.56,0,0,1-5.21,4.1c-1.69,1.18-3.42,2.27-5.14,3.33s-3.48,2.06-5.25,3-3.54,1.9-5.39,2.76a2.72,2.72,0,0,1-3-4.43l0,0c1.43-1.35,2.93-2.66,4.39-4l4.42-3.92c1.47-1.28,2.91-2.59,4.33-3.86.7-.64,1.38-1.29,2-1.93l.93-.93c.3-.31.52-.58.79-.87l-.63.82c.74-1.47,1.44-3,2-4.54s1.17-3.18,1.66-4.82,1-3.29,1.34-5c.2-.83.39-1.67.55-2.51l.45-2.37L195,229a5.42,5.42,0,0,1,10.71,1.62Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.28,263l-5.61-1.66a4.09,4.09,0,0,0-2.82.19l-2.45,1.09a2.34,2.34,0,0,0-1.17,3.15l1.12,2.37a2.34,2.34,0,0,0,2.6,1.3l4.38-.91a10.94,10.94,0,0,0,4.16-.58,2.61,2.61,0,0,0,1.22-3.9h0A2.65,2.65,0,0,0,175.28,263Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,219.23c-4.73,1.77-8.77,5.9-10.72,16.55,2.58,3.28,11.79,5,11.79,5S211.15,226.68,203.2,219.23Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,219.23c-4.73,1.77-8.77,5.9-10.72,16.55,2.58,3.28,11.79,5,11.79,5S211.15,226.68,203.2,219.23Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74,224.4a.32.32,0,0,0,.25.12.31.31,0,0,0,.21-.07.33.33,0,0,0,.05-.46l-2-2.49c-.17.14-.34.28-.5.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,225.72a.33.33,0,0,0,.19.43l.11,0c0-.22-.08-.44-.13-.65A.3.3,0,0,0,206.5,225.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.74,240.46l3.53-5.47c.13-.52.24-1.05.34-1.6a.31.31,0,0,0-.16.12l-4.39,6.79Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4,235a.35.35,0,0,0,.23.09.33.33,0,0,0,.22-.57L194,230c-.08.22-.16.45-.23.68Z",
    style: {
      fill: "#5D7366"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-220"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334,327.82c-1.39-5.42.29-7.48,2.26-9.64s1.75-5.77,1.75-5.77a25.72,25.72,0,0,1,2.16,13.31C339.28,332.94,335,331.78,334,327.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.59,371.52c-2.07-3.47-10.89-10.79-17.58-7.91,5.35,2.22,11.25,15.75,19.17,15.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.81,401.56a1,1,0,0,1-.91-.72c-1.29-5.29-12.72-52.69-17.2-86.34a1,1,0,0,1,.81-1.06.93.93,0,0,1,1.06.81c4.46,33.55,15.87,80.87,17.16,86.15a1,1,0,0,1-.69,1.14Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,316.54c.12-4-1.73-6.41-6.38-6.84s-6.12-2.37-7-4.18c1.57,9.14,12.53,11.43,13.59,15.94C333,318.08,333,316.54,333,316.54Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.11,331.62c-.38-4.16-3.74-4.73-7.57-5.23s-5.09-3-5.09-3a9.72,9.72,0,0,0,2.77,9.65C329.73,337.36,335.39,334.66,335.11,331.62Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.47,368.35c-.66-4.65,2.53-6.57,2-13.4C352.64,370.56,342.51,375.64,341.47,368.35Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.2,349.39c-2.58-3.93-6.24-3.26-10.38-8.71C330.28,358.43,341.24,355.54,337.2,349.39Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.45,350.32c.23-6.28-5.59-9.59-10.05-15.86C349.11,346.94,356.09,360.16,356.45,350.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.59,395.91h-.09a1.1,1.1,0,0,1-1-1.19c1-13.19,4.72-70,3.69-107.18a1.1,1.1,0,0,1,1.07-1.13,1.07,1.07,0,0,1,1.13,1.07c1,37.26-2.65,94.2-3.69,107.41A1.11,1.11,0,0,1,353.59,395.91Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.44,290.53c-1.4-7.61,1.45-12.85,10.28-15s11.09-6.34,12.23-10.08c-.34,18-20.76,25.65-21.49,34.65C356.89,293.49,356.44,290.53,356.44,290.53Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.12,305.9c1.41-9.12-5.47-12.14-13.39-15.27s-9.32-9.06-9.32-9.06a21.51,21.51,0,0,0,.76,22.14C342.53,315.29,356.09,312.55,357.12,305.9Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,329.18c1.51-7.23,7.53-7.55,14.35-7.65s9.55-4.16,9.55-4.16a17.23,17.23,0,0,1-6.83,16.38C365.36,340.35,356,334.46,357.08,329.18Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,364.31c1.66-4.45,10.29-14.78,18.63-12.88-5.71,3.7-9.66,20.58-18.93,21.61C355.76,365.58,355.8,364.31,355.8,364.31Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.78,386.15H336a2.31,2.31,0,0,0-2.21,3l7.53,25.45a2.3,2.3,0,0,0,2.21,1.66h12.77a2.3,2.3,0,0,0,2.21-1.66L366,389.12A2.31,2.31,0,0,0,363.78,386.15Z",
    style: {
      fill: "#5D7366"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.78,386.15H336a2.31,2.31,0,0,0-2.21,3l7.53,25.45a2.3,2.3,0,0,0,2.21,1.66h12.77a2.3,2.3,0,0,0,2.21-1.66L366,389.12A2.31,2.31,0,0,0,363.78,386.15Z",
    style: {
      fill: "#5D7366",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.78,386.15H336a2.31,2.31,0,0,0-2.21,3l7.53,25.45a2.3,2.3,0,0,0,2.21,1.66h12.77a2.3,2.3,0,0,0,2.21-1.66L366,389.12A2.31,2.31,0,0,0,363.78,386.15Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisponibilizar);
export default __webpack_public_path__ + "static/media/disponibilizar.ff17f843f96f1faeb16c3af071282169.svg";
export { ForwardRef as ReactComponent };